module.exports = __webpack_public_path__ + "img/appShare.85b11112.jpg";